import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// LIVEMOA-SELF-LIVE-VALUE-1 · 메인 홍보 영역과 주요기능 사이 배너
export const SelfLiveBanner = ({ content }) => {
  if (!content || content.self_live_banner_visible === false) return null;
  return (
    <section className="px-4 md:px-12 pb-6 md:pb-10 bg-white" data-testid="self-live-banner">
      <div className="max-w-[1340px] mx-auto rounded-[22px] md:rounded-[28px] border border-[#DCE2FF] bg-gradient-to-r from-[#EEF2FF] via-[#F1EDFF] to-[#F7F3FF] px-5 md:px-12 py-6 md:py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-8 main-fade-up">
        <div className="min-w-0">
          <h2 className="text-[19px] md:text-[28px] font-black tracking-tight text-[#1B2140] break-keep" data-testid="self-live-banner-title">
            {content.self_live_banner_title}
          </h2>
          <p className="mt-2 text-[13px] md:text-[16px] text-[#5B6185] leading-relaxed break-keep whitespace-pre-line" data-testid="self-live-banner-desc">
            {content.self_live_banner_desc}
          </p>
        </div>
        <Link to="/why-self-live" data-testid="self-live-banner-btn"
          className="shrink-0 inline-flex items-center justify-center gap-2 h-12 md:h-14 px-6 md:px-7 rounded-2xl bg-gradient-to-r from-[#1E5BFF] to-[#6D3DF5] text-white text-[15px] md:text-[17px] font-bold shadow-[0_8px_22px_rgba(61,107,255,0.3)] hover:brightness-110 transition-[filter]">
          자사 LIVE가 필요한 이유 <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
};
